export default function CurrencyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M13.494 11.868c.247-.165.553-.313.906-.427v2.717a3.688 3.688 0 0 1-.906-.427c-.583-.389-.694-.75-.694-.932 0-.182.111-.543.694-.931ZM17.6 20.558V17.84c.353.114.66.262.907.427.582.388.693.749.693.931 0 .182-.11.543-.693.932a3.688 3.688 0 0 1-.907.427Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 28.8c7.07 0 12.8-5.732 12.8-12.8 0-7.07-5.73-12.8-12.8-12.8S3.2 8.93 3.2 16c0 7.069 5.73 12.8 12.8 12.8ZM17.6 8a1.6 1.6 0 0 0-3.2 0v.146c-.994.187-1.914.548-2.681 1.06-1.155.769-2.119 2.008-2.119 3.593s.964 2.825 2.119 3.594c.767.512 1.687.872 2.681 1.059v3.106c-.625-.203-1.09-.508-1.35-.807a1.6 1.6 0 0 0-2.416 2.097c.9 1.037 2.261 1.72 3.766 2.003V24a1.6 1.6 0 0 0 3.2 0v-.147c.995-.187 1.915-.547 2.682-1.059 1.154-.77 2.118-2.009 2.118-3.594s-.963-2.824-2.118-3.594c-.767-.511-1.687-.872-2.682-1.059V11.44c.626.204 1.09.508 1.35.808a1.6 1.6 0 1 0 2.416-2.097c-.9-1.038-2.261-1.721-3.766-2.004v-.148Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
